export const getFilenameFromContentDisposition = headerContentDisposition => {
    const splittedContentDisposition = headerContentDisposition.split("=")
    const name = splittedContentDisposition[splittedContentDisposition.length - 1]

    return name.replace(/['"]/g, "")
}
